"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Alert_styled_exports = {};
__export(Alert_styled_exports, {
  ActionsWrapper: () => ActionsWrapper,
  AlertHeading: () => AlertHeading,
  CloseWrapper: () => CloseWrapper,
  ContentWrapper: () => ContentWrapper,
  IconWrapper: () => IconWrapper,
  MessageAlert: () => MessageAlert,
  StyledAlert: () => StyledAlert,
  StyledContentContainer: () => StyledContentContainer,
  StyledIconContainer: () => StyledIconContainer,
  StyledSpan: () => StyledSpan
});
module.exports = __toCommonJS(Alert_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var colors = import_baseTheme.default.colors;
var alertVariants = {
  neutral: {
    border: colors.pr[180],
    bg: colors.pr[10]
  },
  success: {
    border: colors.status.success[100],
    bg: colors.status.success[20]
  },
  warning: {
    border: colors.status.warning[100],
    bg: colors.status.warning[20]
  },
  error: {
    border: colors.status.error[100],
    bg: colors.status.error[20]
  }
};
var iconVariants = {
  neutral: {
    color: colors.white,
    bg: colors.pr[180]
  },
  success: {
    color: colors.white,
    bg: colors.status.success[100]
  },
  warning: {
    color: colors.white,
    bg: colors.status.warning[100]
  },
  error: {
    color: colors.white,
    bg: colors.status.error[100]
  }
};
var StyledAlert = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__StyledAlert",
  componentId: "sc-68yz9j-0"
})(function(_ref) {
  var theme = _ref.theme, variant = _ref.variant, alertType = _ref.alertType, maxWidth = _ref.maxWidth;
  return (0, import_styled_components.css)(["", " max-width:", ";min-width:232px;border-radius:8px;border:3px solid ", ";display:flex;font-family:", ";min-height:35px;padding:16px;box-sizing:border-box;p,span{word-break:break-word;}span{font-size:", ";}", ";.inner-close-button,.outer-close-button{", ";}"], (0, import_mixins.mediaBreakpointUp)("lg", "\n      flex-direction: row;\n      width: 100%;\n\n      .inner-close-button {\n        display: none;\n      }\n\n      .outer-close-button {\n        display: block;\n      }\n    "), maxWidth, alertType === "banner" ? alertVariants[variant].bg : alertVariants[variant].border, theme.typography.fonts.primary, theme.typography.headings.h1, alertType === "banner" && "background-color: ".concat(alertVariants[variant].bg), alertType === "banner" && "display: none");
});
var AlertHeading = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__AlertHeading",
  componentId: "sc-68yz9j-1"
})(["", " padding-right:10px;display:flex;align-items:center;"], (0, import_mixins.mediaBreakpointUp)("lg", "\n    align-items: center;\n    margin-bottom: 0;\n  "));
var StyledIconContainer = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__StyledIconContainer",
  componentId: "sc-68yz9j-2"
})(["display:flex;flex-direction:column;"]);
var IconWrapper = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__IconWrapper",
  componentId: "sc-68yz9j-3"
})(function(_ref2) {
  var variant = _ref2.variant;
  return (0, import_styled_components.css)(["align-items:center;background-color:", ";border-radius:50%;color:", ";display:flex;justify-content:center;width:24px;height:24px;"], iconVariants[variant].bg, iconVariants[variant].color);
});
var StyledContentContainer = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__StyledContentContainer",
  componentId: "sc-68yz9j-4"
})(function(_ref3) {
  var theme = _ref3.theme, existSecondAction = _ref3.existSecondAction;
  return (0, import_styled_components.css)(["", " padding-left:", ";display:flex;flex-direction:column;"], (0, import_mixins.mediaBreakpointUp)("md", "\n        flex-direction: ".concat(existSecondAction ? "column" : "row", ";\n        width: 100%;\n        justify-content: space-between;\n    ")), theme.measurements.extraLarge);
});
var ContentWrapper = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__ContentWrapper",
  componentId: "sc-68yz9j-5"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["p.message{margin:4px 0 0 0;font-size:", ";}", " color:", ";display:flex;flex-direction:column;flex-grow:2;align-self:center;p,span{margin:0;}"], theme.typography.textStyles.textSmall, (0, import_mixins.mediaBreakpointUp)("md", "\n      p.message {\n        display: flex;\n      }\n    "), theme.colors.n[100]);
});
var StyledSpan = import_styled_components.default.span.withConfig({
  displayName: "Alertstyled__StyledSpan",
  componentId: "sc-68yz9j-6"
})(["display:flex;align-items:center;"]);
var MessageAlert = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__MessageAlert",
  componentId: "sc-68yz9j-7"
})(function(_ref5) {
  var theme = _ref5.theme, existsActions = _ref5.existsActions;
  return (0, import_styled_components.css)(["", " color:", ";display:flex;flex-direction:row;margin-top:", ";margin-bottom:", ";p,span{margin:0;}"], (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["display:none;"])), theme.colors.n[100], theme.measurements.medium, existsActions ? 0 : "6px");
});
var ActionsWrapper = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__ActionsWrapper",
  componentId: "sc-68yz9j-8"
})(function(_ref6) {
  var marginBetween = _ref6.marginBetween, existSecondAction = _ref6.existSecondAction, theme = _ref6.theme;
  return (0, import_styled_components.css)(["", " ", " display:flex;flex-wrap:wrap;margin-top:", ";"], (0, import_mixins.mediaBreakpointUp)("xs", (0, import_styled_components.css)(["button{&:first-child{margin-top:", ";", ";}&:nth-child(2){margin-top:", ";}}a{margin-top:auto;margin-bottom:auto;&:first-child{", ";}}"], existSecondAction ? "8px" : "0", marginBetween && "margin-right: 15px", existSecondAction ? "8px" : "0", marginBetween && "margin-right: 15px")), (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["justify-content:", ";flex-wrap:nowrap;margin-top:", ";align-items:center;button{&:first-child{margin-top:0;}&:nth-child(2){margin-top:0;}}"], existSecondAction ? "flex-start" : "flex-end", existSecondAction ? "8px" : "0")), theme.measurements.medium);
});
var CloseWrapper = import_styled_components.default.div.withConfig({
  displayName: "Alertstyled__CloseWrapper",
  componentId: "sc-68yz9j-9"
})(function() {
  return (0, import_styled_components.css)(["margin-left:auto;padding-left:16px;"]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionsWrapper,
  AlertHeading,
  CloseWrapper,
  ContentWrapper,
  IconWrapper,
  MessageAlert,
  StyledAlert,
  StyledContentContainer,
  StyledIconContainer,
  StyledSpan
});
//# sourceMappingURL=Alert.styled.js.map